var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/rightChevron.a2c5e251.png","uri@2x": __webpack_public_path__ + "static/media/rightChevron.a2c5e251.png","uri@3x": __webpack_public_path__ + "static/media/rightChevron.cfe77c10.png",
    width: 31,
    height: 48
});